define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/datatables_behavior",
    "views/common/filters_view",
    "views/common/mt4_members_select2_view",
    "bootstrap.datepicker"
], function($, _, Marionette, DatatablesBehavior, FiltersView, Mt4MembersSelect2View){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui:{
            'startDatepicker': '#datetimepicker_start',
            'endDatepicker': '#datetimepicker_end',
            'periodDeposit' : '.period_deposit_data',
            'periodWithdrawal' : '.period_withdrawal_data',
            'filters': '.filter',
            'filterBtn': '#filter_btn',
            'filtersEl': '.filters-el',
            'select2Input': '.select2_input',
            'tradingLink': '#trading_link'
        },

        behaviors: {
            datatables: {
                behaviorClass: DatatablesBehavior
            }
        },

        events:{
            'click @ui.filterBtn': 'filterInitActions'
        },

        filterInitActions: function(){
            this.updateLink();
            this.updateDepositWithdrawal();
        },

        updateLink: function(){
            // We generate the URL filters using the filter array
            if(this.mt4MembersSelect2View.getValue() != ""){

                var urlParam = this.filtersView.getFiltersUrlParam();
                $(this.ui.tradingLink).attr("href", "/report/trading_history/trading?"+urlParam);
            }
        },

        updateDepositWithdrawal: function(){

            var data = this.filtersView.getFiltersDataArray();

            // We get the datas from the server
            var that = this;
            $.ajax({
                url: "/rest_report/trading_history_withdrawal_deposit",
                method: "POST",
                data : data
            }).done(
                function( res ){

                    that.ui.periodDeposit.html( !_.isEmpty(res.deposit) ? res.deposit : " - " );
                    that.ui.periodWithdrawal.html( !_.isEmpty(res.withdrawal) ? res.withdrawal : " - " );
                }
            ).fail(
                function(){
                    // that.ui.periodPL.html("-");
                }
            );
        },

        initialize: function(){

            var that = this;

            this.bindUIElements();
            this.filtersView = new FiltersView({ el: this.ui.filtersEl });
            this.mt4MembersSelect2View = new Mt4MembersSelect2View({ select2El: this.ui.select2Input });
            this.filterInitActions();

            // Initialize our 2 datepickers
            this.ui.startDatepicker.datetimepicker({
                format: 'YYYY-MM-DD'
            });
            this.ui.endDatepicker.datetimepicker({
                format: 'YYYY-MM-DD'
            });

            this.triggerMethod('init:table', {
                url: '/rest_report/trading_history_funds',
                order: [[ 1, "desc" ]],
                columns: [
                    {
                        'name':'mt4_account_no',
                        'data':'mt4_account_no'
                    },
                    {
                        'name':'reg_datetime',
                        'data':'reg_datetime',
                        'type': 'date'
                    },
                    {
                        'name':'type',
                        'data':'type'
                    },
                    {
                        'name':'currency',
                        'data':'currency'
                    },
                    {
                        'name':'amount',
                        'data':'amount'
                    }
                ]
            });
        }
    });
});
